import { Component, Input, OnInit } from '@angular/core';
import {
  DashboardResponse,
  IEPResponse,
  StudentSectionType,
} from '../../../modules/dashboard/interface/dashboard-response';
import { ISedmsFormOutput } from '../../interfaces/form/sedms-form-output.model';
import { IEPService } from 'src/app/modules/iep/iep-document/services/iep.services';
import { LoadingService } from 'src/app/services/loading.service';
import {
  EligibilityDTO,
} from 'src/app/modules/dashboard/interface/eligibility-response';
import { SpecialTransportationRequest } from 'src/app/modules/iep/iep-document/interfaces/special-transportation';

@Component({
  selector: 'app-student-dashboard',
  templateUrl: './student-dashboard.component.html',
  styleUrls: ['./student-dashboard.component.scss'],
  standalone: false,
})
export class StudentDashboardComponent implements OnInit {
  @Input() studentHeaderDetails: DashboardResponse;
  @Input() isPreSchool: boolean;
  transportationDetails?: SpecialTransportationRequest;
  eligibilityResponse: EligibilityDTO;

  readonly twoWeeksInDays: number = 14;
  studentIEP: IEPResponse;
  StudentSectionType: typeof StudentSectionType = StudentSectionType;
  studentHasSection: { key: string; label: string }[] = [
    { key: 'medicalCondition', label: 'Medical Condition' },
    { key: 'physicalLimit', label: 'Physical Limitation' },
  ];

  affectsSection: { key: string; label: string }[] = [
    { key: 'learning', label: 'Learning' },
    { key: 'behavior', label: 'Behavior' },
    { key: 'participation', label: 'Participation' },
  ];

  studentRequiresSection: { key: string; label: string }[] = [
    { key: 'reqMedicalCare', label: 'Requires Medical Care' },
    { key: 'reqHealthCare', label: 'Requires Health Care' },
  ];

  adultSupervisionList: { label: string; condition: () => boolean | undefined }[] = [
    {
      label: '1:1 Paraprofessional',
      condition: (): boolean | undefined => this.transportationDetails?.adultSuperPara,
    },
    {
      label: '1:1 Nursing Services',
      condition: (): boolean | undefined => this.transportationDetails?.adultSuperNursing,
    },
  ];

  vehicleEquipmentList: { label: string; key: string }[] = [
    { label: 'Student uses oxygen', key: 'oxygen' },
    { label: 'Lift Bus', key: 'liftBus' },
    { label: 'Air Conditioning', key: 'airCon' },
    { label: 'Student requires 2 seats (large student)', key: 'twoSeats' },
    {
      label: 'Student requires 3 seats (large student + 1:1 adult supervision)',
      key: 'threeSeats',
    },
    { label: 'Ultraviolet Shield', key: 'uvshield' },
    { label: 'Car Seat', key: 'carSeat' },
    { label: 'Student uses walking aids', key: 'walkingAids' },
    {
      label: 'Student uses wheelchair (Regular Size)',
      key: 'wheelchairReg',
    },
    {
      label: 'Student uses wheelchair (Oversize)',
      key: 'wheelchairOversize',
    },
    {
      label: 'Student cannot ambulate steps / requires lift',
      key: 'cannotAmbulate',
    },
    {
      label: '5-point safety harness / safety vest',
      key: 'fivePointHarness',
    },
    {
      label: 'Other devices or circumstances requiring vehicle modification',
      key: 'otherDevices',
    },
  ];

  otherAccommodationsList: { label: string; key: string }[] = [
    {
      label: 'Specialized Transportation Assistant Services (Porter Services)',
      key: 'isSpecialTransportOtherSite',
    },
    { label: 'Limited Travel Time', key: 'limitedTravelTime' },
    { label: 'Route with Fewer Students', key: 'routeFewerStudents' },
    { label: 'Other Accommodations', key: 'otherAccom' },
  ];

  constructor(
    private iepService: IEPService<ISedmsFormOutput>,
    private loadingService: LoadingService
  ) {}

  ngOnInit(): void {
    this.getIepServices();
  }

  getIepServices(): void {
    this.loadingService.show();
    this.iepService
      .getProgramsAndServicesByNycId(this.studentHeaderDetails?.nycid)
      .subscribe((res: IEPResponse) => {
        this.loadingService.hide();
        this.studentIEP = res;
        if (this.studentIEP?.iepSk) {
          this.getSpecialTransportationService(this.studentIEP?.iepSk);
          this.getEligibility(this.studentIEP?.iepSk);
        }
      });
  }

  getSpecialTransportationService(iepSk: string): void {
    this.iepService.getSpecialTransportationServiceDetails(iepSk).subscribe({
      next: (res: { isRequestSucessful: boolean; value: SpecialTransportationRequest }) => {
        if (res.isRequestSucessful) {
          this.transportationDetails = res.value;
        }
      },
      error: () => {
        // no-op
      },
    });
  }

  getEligibility(iepSK: string): void {
    this.iepService.getEligibility(iepSK).subscribe({
      next: (res: { value: EligibilityDTO }) => {
        this.eligibilityResponse = res.value;
      },
      error: () => {
        // no-op
      },
    });
  }
}
